import { HardDrive, Cpu, MonitorSmartphone, MemoryStick } from "lucide-react";
import SectionTitle from "@/components/site/SectionTitle";
import DownloadButton from "@/components/site/DownloadButton";
import { usePackage } from "@/hooks/usePackage";

const REQ = [
  [Cpu, "Procesor", "Dual Core 2 GHz"],
  [MemoryStick, "RAM", "4 GB"],
  [MonitorSmartphone, "System", "Windows 10 / 11"],
  [HardDrive, "Dysk", "3 GB wolnego miejsca"],
];

export default function DownloadSection({ settings }) {
  const pkg = usePackage();
  const has = pkg?.available || settings.download_url || settings.download_mirror_url;
  return (
    <section id="download" className="relative py-24 md:py-32 overflow-hidden" data-testid="site-download">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#090b1b] to-transparent" />
      <div className="relative px-6 md:px-10 max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <SectionTitle kicker="Rozpocznij przygodę" title="Pobierz klienta gry">
            Pobierz paczkę, a nasz patcher pobierze wszystkie potrzebne pliki, aby uruchomić grę.
          </SectionTitle>
          {pkg === null ? null : has ? (
            <div className="flex flex-col sm:flex-row gap-4">
              <DownloadButton settings={settings} primary label="Pobierz" testId="site-download-main" showSize />
              {settings.download_mirror_url && (
                <a href={settings.download_mirror_url} target="_blank" rel="noreferrer" data-testid="site-download-mirror" className="btn">
                  Mirror
                </a>
              )}
            </div>
          ) : <p className="text-slate-500" data-testid="site-download-soon">Link do pobrania pojawi się wkrótce.</p>}
        </div>
        <div className="grid grid-cols-2 gap-4">
          {REQ.map(([Icon, k, v], i) => (
            <div key={k} className="steel-panel chamfer launcher-rise" style={{ animationDelay: `${i * 80}ms` }}>
              <div className="steel-inner chamfer p-6">
                <Icon className="text-amber-400 mb-6" size={26} />
                <div className="text-[11px] tracking-[0.25em] text-slate-500">{k}</div>
                <div className="text-slate-100 font-semibold mt-1">{v}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
